import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsuarioService } from './usuario.service';
import { URL_SERVICIOS  } from '../config/config';

@Injectable({
 providedIn: 'root'
})
export class UploadService {
 
 constructor(
   private httpClient: HttpClient,
   public _usuario : UsuarioService
 ) { }
 
 public uploadfile(file: File, tipo:any, params:any) {

    // console.log ("Upload service tipo = " + tipo + " params =" + JSON.stringify(params));

   let formParams = new FormData();
   formParams.append('fichero', file);
   formParams.append('TIPO', tipo);
   formParams.append('PARAMETROS', JSON.stringify(params));

    let url = URL_SERVICIOS + 'app/uploads/fileupload.jsp?token=' + this._usuario.token;
    // console.log ('uploadfile-->', url);

    return this.httpClient.post(url, formParams)
 }

  public viewFile (params: any){
    let url = URL_SERVICIOS + 'app/uploads/fileviewer.jsp?token=' + this._usuario.token;
    return url;
    // return this.httpClient.get( url, params );
  }

}
